import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';
import CaptureSourceAttribution from './CaptureSourceAttribution';
import CaptureProcessingReceipt from './CaptureProcessingReceipt';

const CaptureSourceSummaryCard = ({ source, title, personName, entryCount }) => (
  <Paper
    elevation={0}
    sx={{
      p: { xs: 1.35, sm: 1.7 },
      borderRadius: '20px',
      border: `1px solid ${alpha(colors.brand.tint, 0.18)}`,
      bgcolor: '#FFFFFF',
    }}
  >
    <Stack direction="row" spacing={1} alignItems="center">
      <Box
        sx={{
          width: 46,
          height: 46,
          borderRadius: '16px',
          display: 'grid',
          placeItems: 'center',
          bgcolor: alpha(colors.brand.tint, 0.14),
          color: colors.brand.deep,
          flexShrink: 0,
        }}
      >
        <DescriptionOutlinedIcon />
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: '1.2rem', fontWeight: 950, color: colors.semantic.ink, lineHeight: 1.08 }}>
          {title}
        </Typography>
        <Typography sx={{ mt: 0.25, color: alpha(colors.semantic.ink, 0.62), fontWeight: 700 }}>
          {personName || 'This profile'} · {entryCount} timeline moment{entryCount === 1 ? '' : 's'} saved
        </Typography>
      </Box>
    </Stack>
    <CaptureSourceAttribution sources={[source]} />
    <CaptureProcessingReceipt source={source} savedEntryCount={entryCount} />
  </Paper>
);

export default CaptureSourceSummaryCard;
